/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpreasonlabel4Inputs */

const en_coinvestments_declinedeal_gpreasonlabel4 = /** @type {(inputs: Coinvestments_Declinedeal_Gpreasonlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Coinvestments_Declinedeal_Gpreasonlabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpreasonlabel4 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpreasonlabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpreasonlabel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpreasonlabel4(inputs)
});
export { coinvestments_declinedeal_gpreasonlabel4 as "coInvestments_declineDeal_gpReasonLabel" }